// tag blank
var links = document.links;
for (let i = 0, linksLength = links.length ; i < linksLength ; i++) {
    if (links[i].hostname !== window.location.hostname) {
    links[i].target = '_blank';
    links[i].rel = 'noreferrer noopener';
    }
}

// smooth scroll
document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll('a[href="#our-services"]').forEach(link => {
    link.addEventListener("click", function (e) {
      e.preventDefault();
      const target = document.getElementById("our-services");
      if (target) {
        const top = target.getBoundingClientRect().top + window.scrollY - 80;
        window.scrollTo({
          top: top,
          behavior: "smooth"
        });
      }
    });
  });
});
